import React from 'react';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import BynderSelectImageField from './BynderSelectImageField';
import UploadSelectImageField from './UploadSelectImageField';

function SelectImageField(props) {
	return props.config?.general?.bynderEnabled ? <BynderSelectImageField {...props} /> : <UploadSelectImageField {...props} />;
}

export default compose(connect((state) => ({ config: state.config })))(SelectImageField);
